import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { Route, Redirect, Switch } from 'react-router';
import { useHistory } from 'react-router-dom';
import { AuthSession, useAuthSession, usePortalCmsLogout } from '@spins/react-sso-provider';

import Footer from 'components/Footer';
import MainHeader from 'components/MainHeader';
import MainNavigation from 'components/MainNavigation';
import BrandButton from 'components/MainNavigation/BrandButton';
import BrandPickerModal from 'components/Portfolio/BrandPickerModal';
import { hamburgerMenuItemsSelector } from 'containers/AccessControl/selectors';
import ErrorBoundary from 'containers/ErrorBoundary';
import { updateGlobalFilterBrand, clearGlobalFilter } from 'containers/PageHeader/actions';
import Portfolio from 'containers/Portfolio';
import { brandsSelector } from 'containers/Portfolio/PageHeader/selectors';
import Scorecards from 'containers/Scorecards';

import { setCurrentBrand } from 'store/global/actions';
import { enterpriseBrandSelector } from 'store/global/selectors';

import { ROUTES, OTHER_ROUTES } from 'utils/routes';
import { BrandType, GlobalFilterKey } from 'utils/types';

import '../styles.scss';
import SupportButton from "../../../components/SupportButton";

const EnterpriseMain: React.FC = () => {
  const dispatch = useDispatch();
  const enterpriseBrand: string = useSelector(enterpriseBrandSelector);
  const hamburgerMenuItems = useSelector(hamburgerMenuItemsSelector);
  const brands = useSelector(brandsSelector);
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const authSession: AuthSession = useAuthSession();
  const { logout } = usePortalCmsLogout();

  const handleBrandSelect = (client: BrandType) => {
    setShowModal(false);
    dispatch(setCurrentBrand(client.name));
    dispatch(updateGlobalFilterBrand(client.name));
    dispatch(clearGlobalFilter(GlobalFilterKey.GLOBAL));
    history.push(ROUTES.OVERVIEW);
  };

  const getAllowedLinks = () => {
    let allowedLinks = [
      { label: 'Portfolio', route: ROUTES.PORTFOLIO },
      { label: 'Scorecards', route: ROUTES.SCORECARDS },
    ];
    return allowedLinks;
  };

  return (
    <>
      <div className="main-container">
        <Container fluid>
          <Row>
            <MainHeader
              changeBrandLabel="Switch Company"
              currentBrandName={enterpriseBrand}
              items={hamburgerMenuItems}
              userInfo={authSession.user}
              onChangeBrand={() => history.push(OTHER_ROUTES.CHANGE_BRAND)}
              onLogout={() => logout(OTHER_ROUTES.LOGOUT)}
            />
          </Row>
          <Row>
            <MainNavigation
              extra={<BrandButton onClick={() => setShowModal(true)}>Brand Overview</BrandButton>}
              links={getAllowedLinks()}
            />
          </Row>
          <ErrorBoundary>
            <Switch>
              <Route exact path={ROUTES.PORTFOLIO} component={Portfolio} />
              <Route exact path={ROUTES.SCORECARDS} component={Scorecards} />
              <Redirect to={ROUTES.PORTFOLIO} />
            </Switch>
          </ErrorBoundary>
        </Container>
      </div>
      <BrandPickerModal
        brands={brands}
        show={showModal}
        onBrandSelection={handleBrandSelect}
        onClose={() => setShowModal(false)}
      />
      <Footer />
      <SupportButton />
    </>
  );
};

export default EnterpriseMain;
